import MicroModal from 'micromodal';

const Modal = () => {
  const Modals = [...document.querySelectorAll('.Modal')];
  if (!Modals) return;

  MicroModal.init({
    awaitCloseAnimation: true,
    disableFocus: true
  });

  return MicroModal;
};

export default Modal;
